import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-anon-key';

// Check if we have valid Supabase credentials
const hasValidCredentials = supabaseUrl !== 'https://placeholder.supabase.co' && 
                           supabaseAnonKey !== 'placeholder-anon-key' &&
                           supabaseUrl.includes('.supabase.co') &&
                           supabaseAnonKey.length > 20;

if (!hasValidCredentials) {
  console.warn('⚠️  Supabase credentials not configured properly');
  console.warn('Please update your .env file with your actual Supabase URL and anon key');
  console.warn('Current URL:', supabaseUrl);
  console.warn('Current Key:', supabaseAnonKey ? 'Set (but may be placeholder)' : 'Missing');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);

// Export a flag to check if Supabase is properly configured
export const isSupabaseConfigured = hasValidCredentials;